import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DocumentService } from '../../services/document.service';
import { AppConfigService } from '../../../configs';

// import WebViewer from '@pdftron/pdfjs-express';
declare const WebViewer: any;

@Component({
  selector: 'dexio-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})
export class DocumentViewerComponent implements OnInit, AfterViewInit {
  @ViewChild('viewer', { static: false }) viewer: ElementRef | null = null;
  wvInstance: any;

  private viewingText: boolean = false;

  
  private _projectId: string = '';
  get projectId(): string { return this._projectId; }
  @Input() set projectId(value: string) {
    if (value != this.projectId) {
      this._projectId = value;
      if (this.projectId != '' && this.documentId != '') { this.retrieveDocument(); }
    }
  }
  private _documentId: string = '';
  get documentId(): string { return this._documentId; }
  @Input() set documentId(value: string) {
    if (value != this.documentId) {
      this._documentId = value;
      if (this.projectId != '' && this.documentId != '') { this.retrieveDocument(); this.hideText(); }
    }
  }

  private _blobUrl: string = '';
  get blobUrl(): string { return this._blobUrl; }
  set blobUrl(value: string) {
    this._blobUrl = value;
    this.tryToLoadDocument(value);
  }

  private _text: string = '';
  get text(): string { return this._text; }
  set text(value: string) {
    this._text = value;
    if (value && value != '') {
      console.debug('Extracted text: ' + value);
      this.tryToSetText(value);
      this.createTextButton();
    } else {
      this.removeTextButton();
    }
  }

  constructor(private readonly configs: AppConfigService, private readonly documentService: DocumentService) { }

  ngOnInit() { }

  ngAfterViewInit(): void {
    WebViewer({
      path: 'assets/lib',
      licenseKey: this.configs.get().viewerLicenseKey,
      initialDoc: this.blobUrl
    }, this.viewer?.nativeElement).then((instance: any) => {
      this.wvInstance = instance;
      this.getImageViewerContentDiv();
      if (this.text && this.text != null) { this.createTextButton(); }
      this.tryToLoadDocument(this.blobUrl);

      // hide toolbar selections
      instance.UI.disableElements(['toolbarGroup-Shapes']);
      instance.UI.disableElements(['toolbarGroup-Annotate']);
      instance.UI.disableElements(['toolbarGroup-Insert']);
      instance.UI.disableElements(['toolbarGroup-FillAndSign']);
      instance.UI.disableElements(['toolbarGroup-View']);

      instance.UI.disableElements(['toolsHeader']);

      instance.UI.disableElements(['selectToolButton']);
      instance.UI.disableElements(['toggleNotesButton']);
      instance.UI.disableElements(['searchButton']);
      
      instance.UI.disableElements(['languageButton']);
    })
  }

  private tryToLoadDocument(value: string) {
    if (this.wvInstance && value != '') { this.wvInstance.loadDocument(value); }
  }
  private tryToSetText(value: string) {
    if (!this.elm) { console.debug('content div was not found yet'); return; }
    if ((this.elm.nextSibling as any)?.classList.contains('recognized-text')) {
      // text window exists
      var textareas = (this.elm.nextSibling as any)?.querySelectorAll("textarea");
      for (var i = 0; i < textareas.length; i++) {
        textareas[i].innerHTML = value;
      }
    } else {
      this.elm.parentNode?.insertBefore(this.createRecognizedTextDivs(value), this.elm.nextElementSibling);
    }
  }
  private createTextButton() {
    if (this.viewingText == true) { return; }
    if (this.wvInstance) {
      this.wvInstance.UI.setHeaderItems((header: any) => {
        header.headers.default.splice(6,0,{
          type: 'actionButton',
          label: 'TEXT',
          title: 'Show Extracted Text',
          onClick: () => {
            this.showText();
            this.removeTextButton();
            this.createImageButton();
          }
        });
      });
    } else {
      console.debug('webviewer instance was not found while creating the text button');
    }
  }
  private createImageButton() {
    if (this.viewingText = false) { return; }
    if (this.wvInstance) {
      this.wvInstance.UI.setHeaderItems((header: any) => {
        header.headers.default.splice(6,0,{
          type: 'actionButton',
          label: 'IMAGE',
          title: 'Show Image',
          onClick: () => {
            this.hideText();
            this.removeImageButton();
            this.createTextButton();
          }
        });
      });
    }
  }
  private removeTextButton() {
    if (this.wvInstance) {
      this.wvInstance.UI.setHeaderItems((header: any) => {
        var headerIndex = header.headers.default.findIndex((_: any) => _.label == "TEXT");
        if (headerIndex > 0 || header.headers.default[0].label == "TEXT") { header.headers.default.splice(headerIndex, 1); }
      });
    } else {
      console.debug('webviewer instance was not found while removing the text button');
    }
  }
  private removeImageButton() {
    if (this.wvInstance) {
      this.wvInstance.UI.setHeaderItems((header: any) => {
        var headerIndex = header.headers.default.findIndex((_: any) => _.label == "IMAGE");
        if (headerIndex > 0 || header.headers.default[0].label == "IMAGE") { header.headers.default.splice(headerIndex, 1); }
      });
    } else {
      console.debug('webviewer instance was not found while removing the image button');
    }
  }
  private showText() {
    if (!this.elm) { return; }
    const div = this.elm.nextElementSibling;
    if (!div || !div.classList.contains('recognized-text')) { console.debug('recognized text div was not found', document.querySelector('iframe'), document.body.querySelector("div.recognized-text")); return; }
    (div as any).style.display = "block"; 

    (this.elm as any).style.display = "none";
    this.viewingText = true;
  }
  private hideText() {
    if (!this.elm) { return; }
    const div = this.elm.nextElementSibling;
    if (!div || !div.classList.contains('recognized-text')) { console.debug('recognized text div was not found', document.querySelector('iframe'), document.body.querySelector("div.recognized-text")); return; }
    (div as any).style.display = "none"; 

    (this.elm as any).style.display = "block"; 
    this.viewingText = false;
  }
  private retrieveDocument(){
    this.blobUrl = '';
    this.text = '';
    this.removeImageButton();
    this.removeTextButton();
    this.documentService.getDocumentContentsAsBase64(this.documentId, this.projectId)
    .subscribe({
      next: (val: any) => {
        this.blobUrl = val;
      }
    });
    
    this.documentService.getDocumentText(this.documentId, this.projectId)
    .subscribe({
      next: (val: any) => {
        this.text = val;
      }
    });
  }

  private elm: Element | null = null;
  private getImageViewerContentDiv() {
    this.waitForDiv('div.content', 3000, 100) // Wait up to 5 seconds, checking every 100ms
      .then(div => {
        this.elm = div;
        if (this.text && this.text != '') {
          this.tryToSetText(this.text);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  private waitForDiv(selector: string, timeout: number, interval: number): Promise<Element | null> {
    return new Promise((resolve, reject) => {
      let startTime = Date.now();

      const checkDiv = () => {
        let div = document.querySelector(selector);
        if (!div) {
          var iframes = document.querySelectorAll("iframe");
          iframes.forEach(iframe => {
            if (iframe.contentWindow?.document.body.querySelector(selector)) {
              div = iframe.contentWindow?.document.body.querySelector(selector);
            }
          });
        }
        if (div) {
          resolve(div);
        } else if (Date.now() - startTime > timeout) {
          reject(new Error(`Timeout waiting for div with selector: ${selector}`));
        } else {
          setTimeout(checkDiv, interval);
        }
      };

      checkDiv();
    });
  }


  private createRecognizedTextDivs(value: string): HTMLDivElement {
    const textNode = document.createElement("div");
    textNode.classList.add("recognized-text");
    textNode.style.display = "none";
    textNode.style.height = "100%";
    textNode.style.padding = "10px";
    textNode.style.backgroundColor = "white";
    const textTextarea = document.createElement("textarea");
    textTextarea.setAttribute("readonly", "readonly");
    textTextarea.setAttribute("aria-readonly", "true");
    textTextarea.classList.add("recognized-textarea");
    textTextarea.style.height = "100%";
    textTextarea.style.minHeight = "100%";
    textTextarea.style.width = "100%";
    textTextarea.style.minWidth = "100%";
    textTextarea.style.boxSizing = "border-box";
    textTextarea.style.border = "none";
    textTextarea.style.resize = "none";
    textTextarea.innerHTML = value;
    textNode.appendChild(textTextarea);
    return textNode;
  }
}
